import PropTypes from "prop-types"
import React from "react"

const texts = {
  pt: [
    "Quer fazer parte da nossa comunidade? Entre em contato com a gente 😉",
    "A CAMARADES Brasil é feito por pesquisadores para pesquisadores. Nosso objetivo é promover a colaboração e o compartilhamento de conhecimento entre pesquisadores, incluindo meta-pesquisadores, pesquisadores pré-clínicos, clínicos, empresas farmacêuticas, editores, financiadores e formuladores de políticas.",
    <span>
      Se sim, basta entrar na{" "}
      <a
        href="https://join.slack.com/t/camaradesbr/shared_invite/zt-12f82wifb-4F6Nx6rs2NLi2XuJzetPpw"
        target="_blank"
        rel="noopener noreferrer"
      >
        nossa Comunidade no Slack
      </a>
    </span>,
  ],
  en: [
    "Want to be part of our community? Contact us 😉",
    "Researchers make the CAMARADES Brazil for researchers. We aim to promote collaboration and knowledge sharing among researchers, including meta-researchers, preclinical researchers, clinicians, pharmaceutical companies, publishers, funders, and policymakers.",
    <span>
      If so, you can join us on{" "}
      <a
        href="https://join.slack.com/t/camaradesbr/shared_invite/zt-12f82wifb-4F6Nx6rs2NLi2XuJzetPpw"
        target="_blank"
        rel="noopener noreferrer"
      >
        our Slack Community
      </a>
    </span>,
  ],
}

function LimeGradContact({ language }) {
  const text = texts[language]

  return (
    <section className="lime-linear-grad">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h2 className="text-white">{text[0]}</h2>
            <p>{text[1]}</p>
          </div>
          <div className="col-md-6 row">
            <h2 className="text-white">{text[2]}</h2>
          </div>
        </div>
      </div>
    </section>
  )
}

LimeGradContact.propTypes = {
  language: PropTypes.oneOf(["pt", "en"]),
}

export default LimeGradContact
